import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
// import {CookieService} from 'ngx-cookie-service';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import {DeliveryDialogComponent} from './delivery-dialog/delivery-dialog.component';
import {map, switchMap} from 'rxjs/operators';
import {CarsService} from '../cars/cars.service';
import {NbDialogConfig, NbDialogService} from '@nebular/theme';
import {CarModalStellantisComponent} from '../cars/car-modal-stellantis/car-modal-stellantis.component';
import {LoginModalComponent} from '../auth/login/stellantis/login-modal.component';
import {selectLoginState} from '../auth/login/selectors/login.selectors';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from '../reducers';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {CarDialogOverviewComponent} from '../cars/car-dialog-overview/car-dialog-overview.component';

@Component({
  selector: 'app-stellantis-layout',
  templateUrl: './stellantis-layout.component.html',
  styleUrls: ['./stellantis-layout.component.scss']
})
export class StellantisLayoutComponent implements OnInit {

  username = 'guest';
  cars: any;
  fetchedCars: any;
  isLoading = false;
  hasMore = false;
  overlayRef: OverlayRef;
  locatedInIsrael: 'All' | 'Yes' | 'No' = 'All';
  saleCondition: 'All' | 'New' | 'Used' = 'All';
  importType: 'Commercial' | 'Taxi' = 'Commercial';
  shouldHandleQueryParams = true;
  loginStatus$: Observable<any>;
  user: any;

  constructor(public dialog: MatDialog,
              private router: Router,
              private overlay: Overlay,
              private breakpointObserver: BreakpointObserver,
              private cookieService: NgcCookieConsentService,
              private activatedRoute: ActivatedRoute,
              private carsService: CarsService,
              public dialogService: NbDialogService,
              private store: Store<AppState>,
              private ngxService: NgxUiLoaderService,


  ) {
  }

  ngOnInit(): void {
    this.cookieService.hasConsented();
    this.cookieService.close(false);
    this.cookieService.destroy();

    this.loginStatus$ = this.store.select(selectLoginState).pipe(map(loginState => {
      if (loginState.isLogin) {
        this.user = loginState.userData;
        this.username = this.user ? (this.user.first_name + '  ' + this.user.last_name) : 'guest';
      }
      // if (loginState.loading) {
      //   this.ngxService.startLoader('loginLoader');
      // } else {
      //   this.ngxService.stopLoader('loginLoader');
      // }
      return loginState;
    }));

    this.loginStatus$.subscribe((res) => {});


    const authenticated = sessionStorage.getItem('user-id') != null;
    if (!authenticated) {
      const loginRequest = this.dialog.open(LoginModalComponent,
        {
          width: this.isMobileView() ? '400px' : '450px',
          panelClass: 'custom-dialog-padding'
        });

      loginRequest.afterClosed().subscribe(async (res) => {

        if (!res || !res.approve) {
          // this.router.navigate(['/account']);
        } else {
          const deliverySelection = this.dialog.open(DeliveryDialogComponent, {
            width: this.isMobileView() ? '400px' : '450px',
            panelClass: 'custom-dialog-padding',
            disableClose: true,
          });

          deliverySelection.afterClosed().subscribe(res => {
            console.log(`Flag selected: ${res}`);
            this.loadData();
            // if (!res) {
            //   console.log(`Flag selected: ${res}`);
            //   // this.router.navigate(['/account']);
            // } else {
            //   // this.openLoginModal();
            // }
          });
        }
      });

    } else {
      this.loadData();
    }
  }

  isMobileView(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  loadData() {
    // forkJoin([
    this.carsService.filterStellantis({
        page: 1,
        year: -1,
        make: '',
        model: '',
        fueltype: '',
        priceRange: '',
        kmRange: '',
        locatedInIsrael: '',
        saleCondition: '',
        importType: '',
      }
      // }),
      // this.calculatorService.getCurrencies(),
      // this.carsService.getFilterMeta(),
      // ]
    // ).subscribe(([cars, filterMeta]) => {
    ).subscribe((cars) => {
      this.cars = cars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }));
      this.fetchedCars = this.cars;

      // this.currencies = currencies.data;
      // console.log(filterMeta);
      // this.filterMetaCars = filterMeta.cars;
      //
      // this.filterMetaModels = [].concat(...this.filterMetaCars.map(vehicle => vehicle.model));
      //
      // this.filterMetaFuelTypes = ['הכל'].concat(filterMeta.fueltypes);
      // this.fuelTypes = ['הכל'].concat(filterMeta.fueltypes.map((fuelType) => fuelType.label));
      // this.filterMetaYears = ['הכל'].concat(filterMeta.years);
      //
      //
      // this.filterMetaMakes = filterMeta.manufacturers;
      // this.makes = ['הכל'].concat(filterMeta.manufacturers.map((manufacturer) => manufacturer.make_h));
      // // console.log(this.cars);
      // // console.log(new Date().getTime());

      this.overlayRef?.detach();

      this.handleQueryParams();

      // this.hasMore = cars.length === 50;
    });
  }

  handleQueryParams() {
    this.activatedRoute.queryParams
      .pipe(
        switchMap(async (params) => {
          const id = params['id'];
          this.importType = params['importType'] ?? 'Commercial';
          if (id) {
            return await this.getCarDataById(id);
          }
          return null;
        })
      )
      .subscribe(
        (carData) => {
          if (carData) {
            this.toggleMoreInfo(carData);
          } else {
            console.error(`No car data found`);
          }
        },
        (error) => {
          console.error(`An error occurred: ${error}`);
        }
      );
  }

  async getCarDataById(id: string): Promise<any> {
    let carById = this.cars.find((car) => car.id === id);
    if (!carById) {
      const cars = await this.carsService.getCarStellantisById(id).toPromise();
      carById = cars[0];
    }
    return carById;
  }

  toggleMoreInfo(car: any) {

    this.shouldHandleQueryParams = false;
    // await this.router.navigate([], {
    //   queryParams: {
    //     id: car.id,
    //     importType: this.importType
    //   },
    //
    //   queryParamsHandling: 'merge'
    // });



    const isMobile = this.isMobileView();

    const dialogConfig: NbDialogConfig<any> = {
      hasBackdrop: true,
      closeOnEsc: true,
      backdropClass: '',
      dialogClass: isMobile ? 'full-screen-dialog' : '',
      closeOnBackdropClick: false,
      hasScroll: false,
      autoFocus: false,
      viewContainerRef: undefined,
      context: {
        data: car ?? {},
        currencies: [],
        isLoadingCalc: this.isLoading,
        vehicleValue: 0,
        importType: this.importType,
      }
    };


    const dialogRef = this.dialogService.open(CarModalStellantisComponent, dialogConfig);

    if (isMobile) {
      dialogRef.componentRef.instance.nbDialogRef = dialogRef; // Set the dialogRef in the component
    }

    this.carsService.updateInterest(car.id, 'RequestedMoreInfo', this.importType).subscribe((res: any) => {
      console.log('cc', res);
    });

    dialogRef.onClose.subscribe((result: any) => {
      try {
        // setTimeout(() => {
        this.router.navigate([], {
          queryParams: {
            id: null,
            importType: this.importType
          },
          queryParamsHandling: 'merge'
        });
        // });

        // Action to be performed when the dialog closes
        const dialogResult = result ?? dialogConfig.context.data;
        console.log('Dialog closed', dialogResult);




      } catch (err: any) {
        console.error(err);
      }
      this.shouldHandleQueryParams = true;
    });
    // }
    //   else {
    //     alert('הרכב נמכר ולא נמצא במאגר');
    //   }
    // });
  }

  async handleClick(car: any) {
    await this.router.navigate([], {
      queryParams: {
        id: car.id,
        importType: this.importType
      },

      queryParamsHandling: 'merge'
    });
  }

  openDialog(car: any): void {
    this.dialog.open(CarDialogOverviewComponent, {
      width: '80vw',
      data: {car}
    });
  }

  signout() {
    sessionStorage.removeItem('user-id');
    localStorage.clear();
    this.router.navigate(['/stellantis']);
  }

  calcCost(car: any) {
    return car.CarPrice * 0.91 + 500 + car.cost;
  }

}
